import Vue from 'vue'

const setVar = (varName, varValue) => {
    Vue.set(Vue.prototype, varName, varValue)
}

export default setVar
